module.exports = __webpack_public_path__ + "static/media/movie.95496d65.png";